import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    flex: 1;
  }
`;

export default Flex;
